import { groupBy, mapValues } from 'es-toolkit';
import { createSelector } from '@reduxjs/toolkit';

import { AssemblyPlatePart, getAssemblyPlateParts } from './assemblyPartsUtilities';
import { getProductionAnalysisSetComponentDesignByAnalysisSetGuid } from './getProductionAnalysisSetComponentDesignByAnalysisSetGuid';
import { getOrderedProductionComponentInstancesForActiveScheduleLineGroup } from './scheduleStationSelectors';

const recordTrussQuantity = false;

export const getAssemblyPlatePartsForActiveScheduleLineGroup = createSelector(
  getOrderedProductionComponentInstancesForActiveScheduleLineGroup,
  getProductionAnalysisSetComponentDesignByAnalysisSetGuid,

  (
    instancesForActiveScheduleLineGroup,
    productionAnalysisSetComponentDesignByAnalysisSetGuid,
  ): readonly AssemblyPlatePart[] => {
    const analysisSetGuidQuantities = mapValues(
      groupBy(instancesForActiveScheduleLineGroup, ({ analysisSetGuid }) => analysisSetGuid),
      (instances) => instances.length,
    );

    return getAssemblyPlateParts(
      analysisSetGuidQuantities,
      productionAnalysisSetComponentDesignByAnalysisSetGuid,
      recordTrussQuantity,
    );
  },
);
